import api from 'modules/api/index';

export const setClientRiskClassificationRequest = ({ userId, risk, adminName }) => {
  return api.post(`users/${userId}/set-client-risk-classification`, { risk, adminName });
};
